import { render } from "./ProfileRouter.vue?vue&type=template&id=3bf824e5"
import script from "./ProfileRouter.vue?vue&type=script&lang=js"
export * from "./ProfileRouter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__